// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f97e0396","409":"2cf9ed9e","455":"730dde1c","977":"816f191c"}[chunkId] + ".chunk.js";
};